/**
 * Tomorrow's case, sealed: the closed Standard case with a wax seal over its
 * latch and the door's title on a tag, and when it opens. Shown when it is
 * sealed and again on HQ, where it waits.
 */
import caseClosed from "./case-beginner.webp";

export function SealedCase({
  label,
  at,
  compact = false,
}: {
  /** the door it was sealed for */
  label: string;
  /** when it opens (ms epoch) */
  at: number;
  /** on an HQ panel: the case alone, no tag line under it */
  compact?: boolean;
}) {
  const opens = new Date(at).toLocaleString(undefined, {
    weekday: "short",
    hour: "numeric",
    minute: "2-digit",
  });
  if (compact)
    return (
      <div className="relative size-full">
        <img
          src={caseClosed}
          alt=""
          className="absolute inset-0 size-full object-contain"
        />
        <span
          aria-hidden="true"
          className="absolute top-[48%] left-1/2 grid size-[26cqh] -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-[radial-gradient(circle_at_40%_35%,#c93a2c,#7d1d18_60%,#511110)] font-stencil text-[7cqh] tracking-[.1em] text-[#f2dba6] uppercase shadow-[0_4px_12px_rgba(0,0,0,.7),inset_0_1px_0_rgba(255,255,255,.2)]"
        >
          Created
        </span>
      </div>
    );
  return (
    <div className="relative">
      <div className="relative mx-auto aspect-[1451/1084] w-full max-w-[300px] overflow-hidden rounded-[8px] bg-black">
        <img
          src={caseClosed}
          alt=""
          className="absolute inset-0 size-full object-cover"
        />
        {/* the seal, red wax over the latch */}
        <span
          aria-hidden="true"
          className="absolute top-[47%] left-1/2 grid size-[22%] -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-[radial-gradient(circle_at_40%_35%,#c93a2c,#7d1d18_60%,#511110)] font-stencil text-[2.6cqw] tracking-[.1em] text-[#f2dba6] uppercase shadow-[0_4px_12px_rgba(0,0,0,.7),inset_0_1px_0_rgba(255,255,255,.2)] [container-type:inline-size]"
        >
          <span className="text-[min(12px,3.2cqw)]">Sealed</span>
        </span>
        {/* the tag: the door it is for */}
        <span className="absolute right-[6%] bottom-[8%] max-w-[62%] rounded-[3px] bg-[#f3ecd8] px-2 py-1 font-mono text-[10px] leading-tight tracking-[.08em] text-[#2b2107] uppercase shadow-[0_3px_8px_rgba(0,0,0,.6)]">
          For: {label}
        </span>
      </div>
      {!compact ? (
        <p className="mt-2 text-center font-mono text-[11px] tracking-[.14em] text-[#a99d86] uppercase">
          Opens {opens}
        </p>
      ) : null}
    </div>
  );
}
